// Resolved by next.config.js for each build, including the CDN-free sandbox.
export const runtimeAssetPrefix =
  process.env.NEXT_PUBLIC_RUNTIME_ASSET_PREFIX || "";
